/**
 * Created by andrey on 03.06.2025
 */

const Merge2UnitsShopBottomLine = cc.Node.extend({
    ctor: function (unitsShopTab) {
        this.unitsShopTab = unitsShopTab;

        this._super();

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.Merge2UnitsShopBottomLine;

        const background = this.background = cleverapps.UI.createScale9Sprite(bundles.tile_shop.frames.line_png);
        background.setLocalZOrder(-1);
        background.setAlignment({ align: "center" }, { align: "center" });
        this.addChild(background);

        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get("UnitsShop.refreshText"), cleverapps.styles.FONTS.UNITSSHOP_BOTTOM_TEXT);

        const timer = this.timer = new cleverapps.CountDownView(new cleverapps.CountDown(this.unitsShopTab.getLeftTime()), {
            font: cleverapps.styles.FONTS.UNITSSHOP_BOTTOM_TIMER,
            icon: bundles.timer.frames.timer_png,

            background: {
                frame: bundles.timer.frames.timer_bg_png,
                width: styles.timer.background.width,
                height: styles.timer.background.height
            }
        });

        this.content = new cleverapps.Layout([text, timer], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.content.margin
        });

        this.addChild(this.content);

        this.onResize();
    },

    onResize: function () {
        this.stopAllActions();

        const styles = cleverapps.styles.Merge2UnitsShopBottomLine;

        const bgSize = cleverapps.resolution.getBgSize();
        const height = styles.size[cleverapps.resolution.mode].height;

        this.setContentSize(bgSize.width, height);
        this.setAlignment(styles);

        this.showPosition = this.getPosition();
        this.hidePosition = cc.p(this.x, this.y - this.height);

        this.background.setContentSize2(this.width / 0.9, this.height);

        const oldString = this.text.getString();
        const oldTimerScale = this.timer.scale;

        const contentScale = cleverapps.resolution.isVertical() ? 0.6 : 1;

        this.text.setString(Messages.get(cleverapps.resolution.isVertical() ? "UnitsShop.refreshTextShort" : "UnitsShop.refreshText"));
        this.timer.setScale(contentScale);

        this.content.stopAllActions();
        this.content.setScale(1);
        this.content.setOpacity(255);

        if (oldString !== this.text.getString() || oldTimerScale !== this.timer.scale) {
            this.content.reshape();
        }

        const margin = styles.content.margin;
        const availableRect = cc.rect(margin, 0, bgSize.width - margin, this.height);

        if (this.refreshButton) {
            this.refreshButton.baseScale = contentScale;
            this.refreshButton.setScale(contentScale);
            availableRect.width -= this.refreshButton.width * this.refreshButton.scale + margin;
            if (cleverapps.resolution.isVertical() && this.content.width < availableRect.width) {
                availableRect.width -= (availableRect.width - this.content.width) / 2;
            }
        }

        cleverapps.UI.fitToBox(this.content, availableRect);

        this.content.setAlignment({ align: "center" }, styles.content);
        this.content.x = Math.min(this.content.x, availableRect.x + availableRect.width - this.content.width * this.content.scale / 2);

        this.updateRefreshButton();

        if (this.cartRibbon) {
            this.cartRibbon.fitToAvailableRect(cc.rect(0, 0, this.content.x - this.content.width * this.content.scale / 2 - margin, this.height));
        }
    },

    updateRefreshButton: function () {
        if (!this.refreshButton) {
            return;
        }

        this.refreshButton.stopAllActions();
        this.refreshButton.setOpacity(255);

        const styles = cleverapps.styles.Merge2UnitsShopBottomLine;
        const bgSize = cleverapps.resolution.getBgSize();
        const margin = styles.content.margin;
        const content = this.content;
        const scale = this.scale;

        const left = content.x + content.width * content.scale / 2 + margin;
        const right = bgSize.width / scale - margin;
        this.refreshButton.setAlignment((left + right) / 2, styles.content);
    },

    setRefreshButton: function (refreshButton) {
        this.refreshButton = refreshButton;
        this.addChild(refreshButton);

        this.onResize();
    },

    setCartRibbon: function (cartRibbon) {
        this.cartRibbon = cartRibbon;
        this.addChild(cartRibbon);

        this.onResize();
    },

    showUp: function () {
        this.stopAllActions();

        this.setPosition(this.hidePosition);
        this.runAction(new cc.MoveTo(0.13, this.showPosition));

        this.cartRibbon.showUp();

        [this.content, this.refreshButton].forEach((node) => {
            if (!node) {
                return;
            }

            node.setCascadeOpacityEnabledRecursively(true);
            node.setOpacity(0);
            node.setVisible(false);
            node.runAction(new cc.Sequence(
                new cc.DelayTime(0.4),
                new cc.Show(),
                new cc.FadeIn(0.2)
            ));
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNITSSHOP_BOTTOM_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    UNITSSHOP_BOTTOM_TIMER: {
        name: "default",
        size: 50
    }
});

cleverapps.styles.Merge2UnitsShopBottomLine = {
    size: [{ height: 101 }, { height: 141 }, { height: 141 }],

    x: { align: "center" },
    y: { align: "bottom", dy: -5 },

    content: {
        y: { align: "center" },
        margin: 20
    },

    timer: {
        background: {
            width: 300,
            height: 70
        }
    }
};